import * as OlContextMenu from 'ol-contextmenu';
import 'ol-contextmenu/dist/ol-contextmenu.min.css';
import 'Common/Map/OpenLayers/Menu/CustomContextMenu.css';
import OlMap from 'ol/Map';
import { ContextMenuProperties } from 'Common/Map/OpenLayers/Common/ContextMenuProperties';

interface IProps {
    map: OlMap
}

export interface IMenuItem {
    text: string;
    icon?: string;
    classname?: string;
    callback?: Function;
    items?: IMenuItem[];
}

export class ContextMenu {

    map: OlMap

    contextMenu!: any;

    constructor({ map }: IProps) {
        this.map = map;
        this.initializeMenu();
    }

    initializeMenu = () => {
        this.contextMenu = new OlContextMenu({
            width: 200
        });

        this.contextMenu.on('open', this.setMenuItems);
        this.map.addControl(this.contextMenu);
    }

    displayDetails = (resourceUrl: string) => {
        window.open(resourceUrl);
    }

    setMenuItems = (evt: any) => {
        let menuProps: ContextMenuProperties[] = [];
        this.map.forEachFeatureAtPixel(evt.pixel, ft => {
            let contextMenuProps = ft.get("contextMenuProperties");

            if(contextMenuProps){
                menuProps.push(contextMenuProps);
            }
        });

        let items = menuProps.reduce<IMenuItem[]>((items, props) => {

            let destItems = items;

            if (props.parentItem) {
                let parentItem = items.find(item => item.text == props.parentItem);
                if (!parentItem) {
                    parentItem = {
                        text: props.parentItem,
                        items: []
                    };
                    items.push(parentItem)
                }

                destItems = parentItem.items!;
            }

            destItems.push({
                text: props.text,
                callback: props.callback
            })

            return items;
        }, [])

        this.contextMenu.clear();
        this.contextMenu.extend(items);
    }
}